import { CorePermissions } from '@/core/api/collections/users';

export const ERROR_NO_SELF_CHANGES = 'You cannot edit your own permissions';
export const ERROR_NOT_AN_ADMIN = 'You must be an admin to edit permissions';

// Used when enabling core for the first time
export const DEFAULT_CORE_PERMISSIONS: CorePermissions = {
  licenseType: 'fullaccess_admin',
  state: 'active',
  offDuty: false,
  features: 'rw',
  feedback: 'rw',
  tickets: 'rw',
  knowledgebase: 'rw',
  settings: 'rw',
};
